import type { FaireProductEntity } from "../../entity_types/product";

export const p_62t4z97e3y: FaireProductEntity = {
  token: "p_62t4z97e3y",
  type: "product",
  name: "Immunity Bomb Roller / Roll on / Essential oils / Organic / Flu / Cold / Prevention / Recovery / Natural Immune System Boost / kids / adults",
  brandToken: "b_6r1eum8lfs",
  brandName: "Wonderfully Made .love",
  imageUrl:
    "https://cdn.faire.com/fastly/1b3d32b152d034bd847194cbb7da51ff3f6fc234277bd8c42ae51913c5b2fcda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f6a7e41c2fc48aa4f81a8570a9f264ffc24cf2ab43c785d9c329054f63274da.jpeg",
    "https://cdn.faire.com/fastly/23ad81312335abb80094c760a5899ce714a6b79a9714bfc20b264b92f8d3d093.jpeg",
    "https://cdn.faire.com/fastly/e972ae9aba918ba390b71f13005f38b48b32b490d6883075fe1198873a134611.jpeg",
    "https://cdn.faire.com/fastly/e996557f345ed83f0ed70d3df8f9708b4d3a38eb52a7cd9e31710895f9540846.jpeg",
  ],
  priceDollars: 13.3,
  description:
    "Immunity Bomb - A convenient way to boost your immunity, ANYTIME!\n\nMade with therapeutic grade essential oils and an organic carrier base of sweet almond oil. I have been using this blend for over 10 years with wonderful results for myself and entire family! I hope you can enjoy the benefits of it too!\n\nFeel free to contact me with any questions! Thank you for supporting us!\n\nDirections: Roll on feet of littles at night, and on feet and chest of adults every night. Results are best seen with regular use.\n\n10ml Amber Glass roller bottle, STAINLESS STEEL ball w/ green cap.\n\nI am a Certified Essential Oil Coach, not a medical doctor. All information is for educational purposes only. This information had not been evaluated by the FDA and is not intended to diagnose, treat, cure, or prevent any disease.\n",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:13.110Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
